import React, { useState, useEffect } from "react";
import { FiSearch, FiSend, FiX } from "react-icons/fi";

function HeroSection({ onSearch, onQuickAction, searchQuery, onClearSearch }) {
  const [query, setQuery] = useState(searchQuery || "");

  useEffect(() => {
    setQuery(searchQuery || "");
  }, [searchQuery]);

  const quickActions = [
    {
      label: "Vault Migration Plan",
      prompt:
        "Help me migrate my document to Vault CRM for a specific use case. Context:\n- Source system: [Legacy system]\n- Document type: [SOP/Policy/Guide]\n- Target Vault object/type: [Vault object]\n- Compliance constraints: [GxP/21 CFR Part 11/other]\n- Timeline: [date]\n\nReturn:\n1) Migration approach\n2) Field mapping table\n3) Validation checklist\n4) Risks and mitigations\n5) Cutover plan"
    },
    {
      label: "Veeva GPT Terminologies",
      prompt:
        "Explain Vault Migration terminologies in simple and technical language. Include terms like [placeholder terms]. For each term provide:\n- Definition\n- Why it matters in migration\n- Example in Veeva Vault CRM context\n- Common mistakes to avoid"
    },
    {
      label: "Meeting Notes Generator",
      prompt:
        "Generate structured meeting notes from this content:\n[PASTE MEETING TRANSCRIPT OR BULLETS]\n\nUse format:\n- Objective\n- Key decisions\n- Open questions\n- Action items (Owner, Due Date, Status)\n- Risks/Dependencies\n- Next meeting agenda"
    },
    {
      label: "Requirement Analyzer",
      prompt:
        "Analyze this requirement and improve clarity:\n[PASTE REQUIREMENT]\n\nReturn:\n1) Problem statement\n2) Functional requirements\n3) Non-functional requirements\n4) Assumptions and constraints\n5) Acceptance criteria\n6) Gaps/questions for stakeholders"
    },
    {
      label: "Code Generation Spec",
      prompt:
        "Generate production-ready code from this template:\n- Language/Framework: [e.g., React/FastAPI]\n- Feature: [feature name]\n- Input schema: [schema]\n- Output schema: [schema]\n- Error handling: [rules]\n- Performance/Security constraints: [constraints]\n\nAlso include test cases and edge cases."
    },
    {
      label: "SDLC Process Prompt",
      prompt:
        "Act as a prompt engineer and IT SDLC advisor. For initiative [PROJECT_NAME], create prompts and outputs for each phase: Discovery, Requirements, Design, Development, Testing, Deployment, Hypercare. For each phase provide:\n- Reusable prompt template\n- Placeholder inputs\n- Expected output format\n- Review checklist\n- Definition of done"
    }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(query, { fromHomeSubmit: true });
  };

  const handleQuickAction = (action) => {
    setQuery(action.prompt);
    if (onQuickAction) {
      onQuickAction(action.prompt);
      return;
    }
    onSearch(action.prompt);
  };

  const handleClear = () => {
    setQuery("");
    onClearSearch();
  };

  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1 className="hero-title">
          <span className="highlight">ATC GenAI Store</span>
        </h1>
        <p className="hero-subtitle">
          Leverage AI-powered assistants to optimize your productivity and transform how you work.
        </p>
        
        <form className="search-container" onSubmit={handleSubmit}>
          <div className="search-input-wrapper">
            <FiSearch className="search-icon" />
            <input
              type="text"
              className="search-input"
              placeholder="How can i help you?"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              aria-label="Search query"
            />
            {query && (
              <button 
                type="button" 
                className="search-clear-btn" 
                onClick={handleClear}
                aria-label="Clear search"
              >
                <FiX />
              </button>
            )}
            <button type="submit" className="search-submit-btn" aria-label="Submit search">
              <FiSend className="send-icon" />
            </button>
          </div>
        </form>

        <div className="quick-actions">
          <span className="quick-actions-label">Quick actions:</span>
          {quickActions.map((action, index) => (
            <button
              key={index}
              className="quick-action-btn"
              onClick={() => handleQuickAction(action)}
            >
              {action.label}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HeroSection;